import React, { useEffect, useRef, useState } from "react";
import { useThemeColor } from "../Components/Sidebar/SideBarApi";
import { formBtn2, pageClass, pageHeader, TeamLeadExcelBtn } from "../Components/Utils/CustomClasses";
import Table from "../Components/Table/Table";
import { useForm,Controller, get } from "react-hook-form";
import Select from "react-select"; 
import { useSelector } from "react-redux";
import { DatePicker, Space } from "antd";
import { getAllOwnAttendence, StaticUserAPI } from "../API/Api";
import usePaginatedData from "../Components/Utils/UsePagination";
import moment from "moment";
import { customStyles, downloadCSV, onMenuClose, onMenuOpen } from "../Components/Utils/CommonFuntion";
import ButtonLoader from "../Components/Loader/ButtonLoader";
import { toast } from "react-toastify";

export default function Attendence() {

  const { register,setValue, control,reset,handleSubmit,watch } = useForm();
  const userDetails = useSelector((state) => state?.login?.userDetails);
  const filterTimeout = useRef();
  const [AssignUsers, setAssignUsers] = useState([]);
  const [loading, setLoading] = useState(false); 
  const [isMenuOpen, setIsMenuOpen] = useState(false); 
  const [isApplyDisabled, setIsApplyDisabled] = useState(true); 
  const [ariaFocusMessage, setAriaFocusMessage] = useState("");
  const isFirstRender = useRef(true);
  const themeColor = useThemeColor();
  const { RangePicker } = DatePicker; 

  const assignToOptions =
    AssignUsers != undefined
      ? AssignUsers.map((user) => ({
          value: user?._id,
          label: `${user?.first_name} ${user?.last_name} - ${user?.role?.roleName}`,
        }))
      : [{ value: "", label: "No data found" }];

  const user = watch("user"); 
  const rangeDate = watch("rangeDate");

  useEffect(() => {
    setIsApplyDisabled(!(user || rangeDate));
  }, [user, rangeDate]);

  const filterSubmit = async (data) => {
    setLoading(true);
    let startDateFormatted = "";
    let endDateFormatted = "";
    if (data?.rangeDate != undefined && data?.rangeDate?.length != 0) {
      const startDate = `${data?.rangeDate[0].$D}-${ data?.rangeDate[0].$M + 1 }-${data?.rangeDate[0].$y}`;
      const endDate = `${data?.rangeDate[1].$D}-${data?.rangeDate[1].$M + 1}-${data?.rangeDate[1].$y}`;
      startDateFormatted = moment(startDate, "DD-MM-YYYY").format("DD-MM-YYYY");
      endDateFormatted = moment(endDate, "DD-MM-YYYY").format("DD-MM-YYYY");
    }
    const payload = {
      ...filterObject,
      userId: data?.user?.value ? data?.user?.value : "",
      startDate: startDateFormatted,
      endDate: endDateFormatted,
      records:0
    };
    setFilterObject(payload);
  };

  const initialFilterState = {
    p: 1,
    ...(userDetails?.role?.roleName === "SuperAdmin" ? {} : userDetails?.role?.roleName === "Admin" ? { companyId: userDetails?.company?._id, } : { userId: userDetails?._id, companyId: userDetails?.company?._id, })
  };

  const [filterObject, setFilterObject] = useState({ ...initialFilterState });
  const { filterData: OwnAttendenceData, pageNo, nextIsValid, prevIsValid, pageChangeHandler, recordChangeHandler, fetchData, loader } = usePaginatedData(1, 50, getAllOwnAttendence, filterObject);

  const filterRecords = () => {
    if (filterTimeout.current) {
      clearTimeout(filterTimeout.current);
    }
    filterTimeout.current = setTimeout(async () => {
      try {
            await fetchData({ ...filterObject });
          } finally {
            setLoading(false);
            filterTimeout.current = null;
          }
    }, 1500);
    return () => {
      if (filterTimeout.current) {
        clearTimeout(filterTimeout.current);
      }
    };
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false; // Prevent first API call from `useEffect`
      return;
    }
    filterRecords();
  }, [filterObject]);

  const handleCompanySelect = async (id) => {
      const companyId = userDetails?.role?.roleName !== "SuperAdmin" ? userDetails?.company?._id : id;
      setValue("assign_user", null);
      setAssignUsers([])
      try {
        let response2 = await StaticUserAPI({
          id: userDetails?._id,
          role: userDetails?.role?.roleName,
          company: companyId,
        });
        setAssignUsers(response2?.data?.filteredData);
      } catch (err) {
        console.log("Error", err);
      }
 };

 useEffect(() => {
    handleCompanySelect(userDetails?.company?._id);
  }, []);

  const getBreakDuration = (inTime, outTime) => {
    if (!inTime || !outTime) return null;

    const inMoment = moment(inTime, "h:mm A");
    const outMoment = moment(outTime, "h:mm A");
    const duration = moment.duration(outMoment.diff(inMoment));
    const minutes = duration.asMinutes();

    return minutes > 0 ? `${Math.floor(minutes)} mins` : "0 mins";
  };

  const tableColumns = [
    {
      field: "name",
      header: "Full Name",
      style: true,
      className: "col-name",
      body: (row) => {
        const firstName = row?.userId?.first_name || "";
        const lastName = row?.userId?.last_name || "";
        const fullName = (firstName && lastName) ? `${firstName} ${lastName}` : firstName || lastName || "-----";
        return <h6>{fullName}</h6>;
      },
    },
    {
      field: "email",
      header: "Email",
      style: true,
      className: "col-email",
      body: (row) => <h6>{row?.userId?.email ? row?.userId?.email : "------"}</h6>,
    },
    {
      field: "date",
      header: "Date",
      style: true,
      body: (row) => <h6>{moment(row.date).format("DD-MM-YYYY") ? moment(row.date).format("DD-MM-YYYY") : "-----"}</h6>,
    },
    {
      field: "inTime",
      header: "In Time",
      style: true,
      className: "col-intime",
      body: (row) => <h6>{row?.inTime ? row?.inTime : "------"}</h6>,
    },
    {
      field: "outTime",
      header: "Out Time",
      style: true,
      className: "col-outtime",
      body: (row) => <h6>{row?.outTime ? row?.outTime : "-------"}</h6>,
    },
    {
      field: "breakTime",
      header: "Break Time",
      style: true,
      body: (row) => (
        <h6>
          {row?.break === true
            ? getBreakDuration(row?.inTime, row?.outTime) || "-----"
            : "-----"}
        </h6>
      ),
    },
    {
      field: "break_type",
      header: "Break Type",
      style: true,
      body: (row) => <h6>{row?.break_type ? row?.break_type : "------"}</h6>,
    },
    {
      field: "remark",
      header: "Remark",
      style: true,
      className: "col-remark",
      body: (row) => <h6>{row?.remark ? row?.remark : "------"}</h6>,
    },
    {
      field: "comment",
      header: "Comment",
      style: true,
      className: "col-comment",
      body: (row) => <h6>{row?.comment ? row?.comment : "------"}</h6>,
    },
  ];

  const submitPdfExcel = async () => {
  try {
   
    const formUser = watch("user");
    const formRangeDate = watch("rangeDate");

    let startDateFormatted = "";
    let endDateFormatted = "";

    if (formRangeDate?.length === 2) {
      const startDate = `${formRangeDate[0].$D}-${formRangeDate[0].$M + 1}-${formRangeDate[0].$y}`;
      const endDate = `${formRangeDate[1].$D}-${formRangeDate[1].$M + 1}-${formRangeDate[1].$y}`;

      startDateFormatted = moment(startDate, "DD-MM-YYYY").format("DD-MM-YYYY");
      endDateFormatted = moment(endDate, "DD-MM-YYYY").format("DD-MM-YYYY");
    }

    const payload = {
      ...initialFilterState,
      userId: formUser?.value || "",
      startDate: startDateFormatted,
      endDate: endDateFormatted,
      p: 1,
      records: 0
    };

    const response = await getAllOwnAttendence(payload);
    const AttendDataAll = response?.data?.filteredData || [];

    const Header = [
      "name",
      "email",
      "date",
      "inTime",
      "outTime",
      "breakTime",
      "break_type",
      "remark",
      "comment",
    ];

    const formattedAttendsData = AttendDataAll.map((row) => ({
      name: row?.userId?.first_name && row?.userId?.last_name 
        ? `${row?.userId?.first_name} ${row?.userId?.last_name}`
        : row?.userId?.first_name || row?.userId?.last_name || "",
      email: row?.userId?.email || "",
      date: row?.date ? moment(row.date).format("DD-MM-YYYY") : "",
      inTime: row?.inTime || "",
      outTime: row?.outTime || "",
      breakTime: row?.break === true
        ? getBreakDuration(row?.inTime, row?.outTime)
        : "",
      break_type: row?.break_type || "",
      remark: row?.remark || "",
      comment: row?.comment || "",
    }));

    downloadCSV(Header, formattedAttendsData, "Attendence");

  } catch (err) {
    console.log("Error:", err);
    toast.error("Failed to download Excel");
  }
};

  return (
    <>
      <div className={`${pageClass} attendance-page`}>
        <div className="bg-[#FFFFFF] p-10 rounded-xl">
          <div className="flex items-center justify-between">
            <h1 className={`${pageHeader}`}>
              {" "}
              {userDetails?.role?.roleName === "Admin" ||
              userDetails?.role?.roleName === "SuperAdmin"
                ? "Attendance "
                : "Own Attendance "}{" "}
            </h1>
            {(userDetails?.role?.roleName === "Admin" ||
              userDetails?.role?.roleName === "SuperAdmin") && (
              <button
                className={TeamLeadExcelBtn}
                onClick={() => submitPdfExcel()}
              >
                Excel
              </button>
            )}
          </div>
          <form onSubmit={handleSubmit(filterSubmit)}>
            <div className="flex flex-col lg:flex-row gap-3 mt-4">
              {/* FILTERS DIV */}
              <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
                {userDetails?.role?.roleName === "Admin" && (
                  <>
                    <div>
                      <Controller
                        name="user"
                        control={control}
                        render={({ field }) => (
                          <Select
                            {...field}
                            styles={customStyles}
                            aria-labelledby="aria-label"
                            inputId="aria-example-input"
                            onMenuOpen={onMenuOpen(setIsMenuOpen)}
                            onMenuClose={onMenuClose(setIsMenuOpen)}
                            options={assignToOptions}
                            placeholder="Select User"
                            isClearable
                            noOptionsMessage={() => "No user available"}
                            maxMenuHeight={220}
                          />
                        )}
                      />
                    </div>

                    {/* Date Field */}
                    <div>
                      <Space direction="vertical" size={12} className="w-full">
                        <Controller
                          name="rangeDate"
                          control={control}
                          render={({ field }) => (
                            <RangePicker
                              {...field}
                              className="w-full h-[48px] rounded-lg border border-gray-300 px-3 shadow-none focus:shadow-none hover:shadow-none"
                              placement="bottomLeft"
                              getPopupContainer={() => document.body}
                              dropdownClassName="custom-date-picker-dropdown"
                            />
                          )}
                        />
                      </Space>
                    </div>
                  </>
                )}
              </div>

              {/* BUTTON DIV */}
              {userDetails?.role?.roleName === "Admin" && (
                <div className="flex gap-2 justify-end flex-shrink-0 items-center">
                  {loading ? (
                    <ButtonLoader />
                  ) : (
                    <button
                      type="submit"
                      className={`bg-base-color text-white rounded-lg px-4 py-2 ${
                        isApplyDisabled
                          ? "opacity-50 cursor-not-allowed"
                          : "cursor-pointer"
                      }`}
                      disabled={isApplyDisabled}
                    >
                      Apply
                    </button>
                  )}

                  <button
                    type="button"
                    className={`${formBtn2} ${
                      isApplyDisabled
                      ? "opacity-50 cursor-not-allowed"
                      : ""
                    }`}
                    onClick={() => {
                      reset({ user: null, rangeDate: null });
                      setFilterObject(initialFilterState);
                    }}
                    disabled={isApplyDisabled}
                  >
                    Clear
                  </button>
                </div>
              )}
            </div>
          </form>
          <div className="mt-4">
            <Table
              columns={tableColumns}
              data={OwnAttendenceData}
              paginatorCheck={true}
              prevIsValid={prevIsValid}
              nextIsValid={nextIsValid}
              pageNo={pageNo}
              pageChangeHandler={pageChangeHandler}
              recordChangeHandler={recordChangeHandler}
              register={register}
              records={filterObject?.records}
              loading={loader}
            />
          </div>
        </div>
      </div>
    </>
  );
}